import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { profit: { getProfit, } } = apiUrls;

export const GET_AMAZON_PROFIT_SUCCESS = 'GET_AMAZON_PROFIT_SUCCESS';
export const GET_AMAZON_PROFIT_LOADING = 'GET_AMAZON_PROFIT_LOADING';


export const getProfitData = ({ from: fromYear, to: toYear,
    fromMonth, toMonth, vendor }) => async (dispatch) => {
        try {
            if (vendor) {
                const requestData = {
                    ...getProfit,
                    url: getProfit.url.replace('{{vendor}}', vendor),
                    data: {
                        toYear,
                        fromYear,
                        fromMonth,
                        toMonth,
                    }
                };
                const data = await REQUEST(requestData);
                dispatch({
                    type: GET_AMAZON_PROFIT_SUCCESS,
                    data,
                    vendor
                })
            }

        } catch (e) {

            dispatch({
                type: GET_AMAZON_PROFIT_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
                vendor
            })
        }


    }


export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: GET_AMAZON_PROFIT_LOADING,
            isLoading,
            vendor
        });
    }
}

